import React from "react";
import { Navigate, createHashRouter } from "react-router-dom";

// routes
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
// import Modals from "../../src/views/pages/dashboard/modalList";
import Layout from "../ui-components/menus/layout/Layout";
import Dashboard from "../views/pages/dashboard";

// ==============================|| ROUTING RENDER ||============================== //

const router = createHashRouter([
  // {
  //   path: "/",
  //   element: <Navigate to="/dashboard" replace />, // start at /modal
  // },
  // {
  //   path: "/",
  //   element: <Layout />, // layout with sidebar
  //   children: [
  //     {
  //       path: "/dashboard",
  //       element: <Dashboard />,
  //     },
  //     // other routes inside sidebar layout
  //   ],
  // },
  {
    path: '/',
    element: <Navigate to="login" replace />,
  },
  LoginRoutes,
  MainRoutes,
]);

export default router;
